import notEmpty from "./notEmpty/index.js";
function cleanData(edges) {
    const nonEmptyEdges = edges.filter(notEmpty);
    const shapedData = nonEmptyEdges.map((edge)=>edge.node).filter(notEmpty);
    return shapedData;
}
const src_cleanData = cleanData;
export default src_cleanData;
